import ServicePage from './ServicePage';

const HabiliteSociale = () => <ServicePage serviceKey="socialSkills" />;

export default HabiliteSociale;
